module.exports = __webpack_public_path__ + "img/PM_A02_back_horizontal_en.bddb147f.png";